import type { TimeSlotMenu } from '../types/timeSlots';

/**
 * Match a slot menu against an area.
 *
 * The backend exposes `menu.area` as a legacy field that historically stored
 * the area NAME but in newer area-mode restaurants stores the area ID. To
 * bridge both shapes without breaking consumers, we compare against both the
 * area id (stringified) and the area name. A single source of truth here
 * keeps all callers in sync in case the contract evolves.
 */
export function menuMatchesArea(
  menu: TimeSlotMenu,
  area: { id: string | number; name: string },
): boolean {
  return String(menu.area) === String(area.id) || menu.area === area.name;
}

/**
 * Filter a slot's enabled menus to those offered in the given area.
 */
export function filterSlotMenusByArea(
  menus: TimeSlotMenu[],
  area: { id: string | number; name: string },
): TimeSlotMenu[] {
  return menus.filter((m) => menuMatchesArea(m, area));
}
